import axios from '@/utils/request'
import utils from '@/utils/index.js'
var Qs = require('qs')

export default {
    types_all: ["purchaseReceive", "purchaseChangeSpecsReceive", "purchaseForceReceive", "purchaseChangeSpecsForceReceive", "purchaseRework",
        "returnBack", "returnBackRework", "inventoryRework", "manufactureReceive",
        "manufactureForceReceive",
        "manufactureRework",],


    // 2020-11-20
    search(params) {
        return axios.get('/receives?' + Qs.stringify(params, { arrayFormat: 'repeat' }));
    },
    // 2020-11-20
    batchReceive(params) {
        return axios.put('/receives/batch-receive', params);
    },
    // 2021-01-25
    batchReceiveAndQuality(params) {
        return axios.put('/receives/batch-receive-and-quality', params);
    },
    // 2021-02-01
    batchReceiveAndQualityAndPush(params) {
        return axios.put('/receives/batch-receive-and-quality-and-push', params);
    },
    // 2021-02-01
    batchReceiveAndQualityAndDelivery(params) {
        return axios.put('/receives/batch-receive-and-quality-and-delivery', params);
    },
    // 2021-03-10
    batchQualityAndDelivery(params) {
        return axios.put('/receives/batch-quality-and-delivery', params);
    },
    // 2020-11-21
    changeSpecsReceive(id, params) {
        return axios.put('receives/' + id + '/change-specs-receive', params);
    },
    // 2020-11-28
    pendingReceiveCount() {
        return axios.get('receives/pending-receive-count');
    },
    // 2020-12-23
    findByWorkerOrderId(workOrderId) {
        return axios.get('/mes/receives/find-by-work-order-id/' + workOrderId);
    },
    // 2020-12-24
    insertBatch(params) {
        return axios.post('/mes/receives/insert-batch', params);
    },

    // 2021-02-19
    scanSerialNo(params) {
        return axios.get('/receives/scan-serial-no', params);
    },
    // 2021-02-19
    scanReceive(params) {
        return axios.put('/receives/scan-receive', params);
    },
}
